import React from 'react';
import { getDateObjFromString } from '../payment-history/helper';
import { phoneTypeList } from '../shared/FancySelect';
import { isAllowed } from '../shared/permissions/RestrictTo';
import { PERMISSION_APPROVED_DRIVER, PERMISSION_COORDINATOR, PERMISSION_SUBSCRIPTION_USER } from '../shared/permissions/permissions';

export function validatePhone(phoneObj, canBeEmpty = false) {
  if (phoneObj) {
    const numberValid = canBeEmpty ? (phoneObj.number && phoneObj.number.length === 12 || !phoneObj.number) : phoneObj.number && phoneObj.number.length === 12;
    const typeValid = canBeEmpty ? true : phoneTypeList.indexOf(phoneObj.type) !== -1;
    return numberValid && typeValid;
  } else {
    return canBeEmpty;
  }
}

export function getDriverStatus(driverStatus, licenseExpiryObj, userProfile, driverMvrStatus) {
  if (!driverStatus) {
    return { status: 'N/A' };
  }

  const status = driverStatus.toLowerCase();
  const isPendingMvr = !!(userProfile && userProfile.isPendingMvr);

  if (status.includes('exception') || status.includes('pending')) {
    return {
      status: 'pending',
      newException: !isPendingMvr
    };
  }

  if (status.includes('declined')) {

    const expiry = checkExpiry(licenseExpiryObj, driverStatus);
    // if (expiry.status === 'declined' && expiry.remainingDays < -30) {
    //   return { status: 'declined', expired: true, dayDiff: expiry.remainingDays };
    // }
    // if (expiry.status === 'expired') {
    //   return { status: 'declined', expired: true, dayDiff: expiry.remainingDays };
    // }
    const isExpiredPast30days = expiry.remainingDays < -30 && (driverMvrStatus && driverMvrStatus.toLowerCase().includes('expired license'));
    const isExpiredWithin30days = (expiry.remainingDays < 0 && expiry.remainingDays >= -30) && (driverMvrStatus && driverMvrStatus.toLowerCase().includes('expired license'));
    return { 
      status: 'declined', 
      expired: expiry.remainingDays <= 0 ? true : false, 
      dayDiff: expiry.remainingDays,
      isExpiredPast30days: isExpiredPast30days,
      isExpiredWithin30days: isExpiredWithin30days
     };
  }

  if (status.includes('approved') && !isPendingMvr) {

    const expiry = checkExpiry(licenseExpiryObj, driverStatus);

    if ( expiry.remainingDays >= 0 && expiry.remainingDays <= 30) {
      return { status: 'expiring', dayDiff: expiry.remainingDays };
    }
    if (expiry.remainingDays > 30) {
      return { status: 'approved', dayDiff: expiry.remainingDays };
    }
    if (!expiry.status) {
      return { status: 'approved', hideDriverBanner: true };
    }
    return { ...expiry, dayDiff: expiry.remainingDays };
  }

  if (status.includes('expired')) {
    return { status: 'expired' };
  }

  return {};
}

function checkExpiry(licenseExpiryObj, currentStatus) {
  let status = {};
  if (licenseExpiryObj && licenseExpiryObj.licenseExpiry) {
    const today = new Date();
    const expiryDate = new Date(licenseExpiryObj.licenseExpiry);
    const dateInfo = getDateObjFromString(licenseExpiryObj.licenseExpiry);
    const dateStr = `${dateInfo.month.substring(0, 3)} ${dateInfo.day}, ${dateInfo.year}`;
    const diff = expiryDate.getTime() - today.getTime();
    const dayDiff = (diff / (1000 * 60 * 60 * 24)).toFixed();

      if (dayDiff >= 0 && dayDiff <= 5) {
        status = {
          status: "expiring",
          remainingDays: dayDiff,
          dateInfo: dateStr,
        };
      }else if (dayDiff >= 6 && dayDiff <= 30) {
        //expired in between 6 to  30 days 
        status = {
          status: "expiring",
          remainingDays: dayDiff,
        };
      }
      else if (currentStatus.toLowerCase().includes('approved') && dayDiff > 30) {
        //expired in past
        status = {
        status: 'approved',
        remainingDays: dayDiff //Math.abs(dayDiff),
        };
      }
      else if (currentStatus.toLowerCase().includes('declined')) {
        //expired in past
        status = {
        status: 'declined',
        remainingDays: dayDiff // Math.abs(dayDiff),
        };
      }
      else if (dayDiff < 0) {
        //expired in past 
        status = {
          status: "expired",
          remainingDays: dayDiff
        };
      }
  }
  return status;
}

export function convertKeysToLowerCase(obj) {
  const convertedObject = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      convertedObject[key.toLowerCase()] = obj[key];
    }
  }
  return convertedObject;
}

export function shouldShowAddress(stop, participantID) {
  if (isAllowed([PERMISSION_SUBSCRIPTION_USER])) {
    const isParticipantOfStop = stop?.todaysParticipants.some(participant => participant.id === participantID);
    if (!stop.isPrivateAddress || isAllowed([PERMISSION_COORDINATOR, PERMISSION_APPROVED_DRIVER]) || isParticipantOfStop) {
      return true;
    } return false;
  }
  return true;
}

export function shouldShowAddressToParticipant(stop, participantID, viewedParticipantID) {
  if (isAllowed([PERMISSION_SUBSCRIPTION_USER])) {
    if (!stop.isPrivateAddress || isAllowed([PERMISSION_COORDINATOR, PERMISSION_APPROVED_DRIVER]) || participantID === viewedParticipantID) {
      return true;
    } return false;
  } return true;
}